<template>
  <a-modal
    :wrapClassName="disabeld ? 'ps-see-form-modal' : ''"
    :title="title"
    width="40%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    @cancel="handleCancel"
    @ok="submit"
    :ok-text="saveText"
    cancel-text="取消"
  >
    <div>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="支出资金来源" prop="lxSubsudyFundId">
          <div class="flex">
            <a-select
              v-model="form.lxSubsudyFundId"
              @change="changeSource"
              :disabled="disabeld"
            >
              <a-select-option :value="item.value" v-for="item in xwlist">{{
                item.title
              }}</a-select-option>
            </a-select>
            <!-- <span class="surplus-money"> 剩余{{ form.surplusMoney }}元 </span> -->
          </div>
        </a-form-model-item>
        <a-form-model-item label="支出年份" prop="costYear">
          <a-date-picker
            placeholder="请选择年份"
            v-model="form.costYear"
            :open="yearShowOne"
            :locale="locale"
            :format="'YYYY'"
            mode="year"
            @openChange="openChangeOne"
            @panelChange="panelChangeOne"
            @change="handleClearAcquireYear"
            :disabled="disabeld"
          />
        </a-form-model-item>
        <a-form-model-item label="支出项目" prop="project">
          <a-input v-model="form.project" :disabled="disabeld" />
        </a-form-model-item>
        <a-form-model-item label="支出金额" prop="amount">
          <div class="flex">
            <a-input-number
              :min="0"
              v-model="form.amount"
              :disabled="disabeld"
            />
            <span class="surplus-money"> 元 </span>
          </div>
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>

<script>
import { getAction, postAction, putAction } from "@/api/index";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      other: "",
      form: {
        applyId: "",
        lxSubsudyFundId: "",
        project: "",
        amount: "",
        surplusMoney: 0,
        costYear: "",
      },
      yearShowOne: false,
      rules: {
        lxSubsudyFundId: [
          {
            required: true,
            message: "请选择资金来源",
            trigger: "change",
          },
        ],
        project: [
          {
            required: true,
            message: "请输入使用项目",
            trigger: "blur",
          },
        ],
        amount: [
          {
            required: true,
            message: "请输入金额",
            trigger: "blur",
          },
        ],
        costYear: [
          {
            required: true,
            message: "请选择支出年份",
            validator: (rule, value, callback) => {
              if (this.form.costYear != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择支出年份"));
              }
            },
            trigger: "blur",
          },
        ],
      },
      zh_CN,
      locale,
      applyType: 2,
      // 添加还是编辑
      type: "",
      // 弹框标题
      title: "",
      xwlist: [],
      moneyData: {}, // 来源及剩余金额的集
      disabeld: false,
      taskId: null,
      detailId: null,
      saveText: "保存",
      teacherdata: {},
    };
  },
  methods: {
    init(type, record, taskId, detailId) {
      this.type = type;
      this.visible = true;

      if (type == "add") {
        this.form = {
          surplusMoney: 0,
        };
        this.getxwlist(record.id);
        this.form.applyId = record.id;
        this.form.costYear = new Date().getFullYear() + "";
        this.title = "添加资金支出";
      } else if (type == "edit") {
        this.title = "编辑资金支出";
        this.getxwlist(record.applyId);
        this.form = {
          lxSubsudyFundId: record.lxSubsudyFundId,
          project: record.project,
          amount: record.amount,
          applyId: record.applyId,
          id: record.id,
          costYear: record.costYear,
        };
        this.teacherdata = record;
      } else if (type === "audit-edit") {
        this.title = "编辑资金支出";
        this.saveText = "提交";
        this.taskId = taskId;
        this.detailId = detailId;
        this.getxwlist(record.applyId);
        this.form = {
          lxSubsudyFundId: record.lxSubsudyFundId,
          project: record.project,
          amount: record.amount,
          applyId: record.applyId,
          id: record.id,
          costYear: record.costYear,
        };
      } else {
        this.disabeld = true;
        this.title = "查看资金支出";
        this.saveText = "关闭";
this.getxwlist(record.applyId);
        this.form = {
          lxSubsudyFundId: record.lxSubsudyFundId,
          project: record.project,
          amount: record.amount,
          applyId: record.applyId,
          id: record.id,
          costYear: record.costYear,
        };
      }
      this.getFundsSource(this.form.applyId);
    },
    getFundsSource(applyId) {
      const params = {
        applyId,
      };
      getAction(
        "/baseCommon/getDictItemsByCode?code=capital_source",
        params
      ).then((res) => {
        console.log("res", res);
        const resData = res.result;
        this.moneyData = resData;
        this.xwlist = resData;
        if (this.form.lxSubsudyFundId) {
          let item = this.moneyData.filter(
            (item) => item.value == this.form.lxSubsudyFundId
          );
          this.form.surplusMoney = item[0].amount;
          // this.form.surplusMoney = this.moneyData[this.form.lxSubsudyFundId];
        }
      });
    },
    changeSource(e) {
      console.log(this.moneyData, "e", e);
      let item = this.moneyData.filter((item) => item.value == e);
      this.form.surplusMoney = item[0].amount;
    },
    handleCancel() {
      this.visible = false;
    },
    getxwlist(ids) {
      // this.xwlist = [
      //   {
      //     value: "省补贴",
      //     title: "省补贴",
      //   },
      //   {
      //     value: "地方补贴",
      //     title: "地方补贴",
      //   },
      //   {
      //     value: "学校自筹",
      //     title: "学校自筹",
      //   },
      //   {
      //     value: "其他来源",
      //     title: "其他来源",
      //   },
      // ];
      //   getAction("/lxBase/lxSubsidyFund/lxApplyList", {applyId:ids}).then((res) => {
      //         if (res.code == 200) {
      //           console.log(res);
      //           this.xwlist=res.result;
      //         }
      // });
    },
    submit() {
      if (this.disabeld) {
        this.visible = false;
        return;
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.type == "add") {
            let params = this.form;
            params.applyType = this.applyType;
            // params.applyId = "1829722136428707841";
            if (
              typeof this.form.costYear == "object" &&
              this.form.costYear != "" &&
              this.type == "add"
            ) {
              this.form.costYear =
                new Date(this.form.costYear).getFullYear() + "";
            }

            postAction("/lxBase/lxSubsidyFundCost/add", params).then((res) => {
              if (res.code == 200) {
                this.visible = false;
                this.$message.success("添加成功");
                this.$emit("foundPay");
              } else {
                this.$message.error(res.message);
              }
            });
          } else if (this.type == "audit-edit") {
            let params = {
              taskId: this.taskId,
              afterJson: JSON.stringify({ ...this.form }),
              detailId: this.detailId,
            };
            if (
              typeof this.form.costYear == "object" &&
              this.form.costYear != "" &&
              this.type == "add"
            ) {
              this.form.costYear =
                new Date(this.form.costYear).getFullYear() + "";
            }

            postAction("/audit/lxAuditTask/reSubmitTask", params).then(
              (res) => {
                if (res.code == 200) {
                  this.visible = false;
                  this.$message.success(res.message || "编辑成功");
                  this.$emit("foundPay");
                } else {
                  this.$message.error(res.message);
                }
              }
            );
          } else {
            if (
              this.teacherdata?.status == "0" ||
              this.teacherdata?.status == "1" ||
              this.teacherdata?.status == "4" ||
              this.teacherdata?.status == "3" ||
              (this.teacherdata?.status == "2" && this.teacherdata?.operation)
            ) {
              let params1 = this.form;
              params1.applyType = this.applyType;
              // params.applyId = "1829722136428707841";
              if (typeof this.form.costYear == "object") {
                params1.costYear =
                  new Date(this.form.costYear).getFullYear() + "";
              }
              let params = {
                id: this.teacherdata?.taskId,
                applicationData: JSON.stringify(this.$nullToEmpty(params1)),
              };
              if (this.teacherdata?.status == "4") {
                params.auditState = "1";
              }
              putAction("/audit/lxAuditTask/editTaskAndDetail", params).then(
                (res) => {
                  if (res.code == 200) {
                    this.visible = false;
                    this.$message.success("编辑成功");
                    this.$emit("foundPay");
                  } else {
                    this.$message.error(res.message);
                  }
                }
              );
            } else {
              let params = this.form;
              params.applyType = this.applyType;
              // params.applyId = "1829722136428707841";
              if (typeof this.form.costYear == "object") {
                params.costYear =
                  new Date(this.form.costYear).getFullYear() + "";
              }
              putAction("/lxBase/lxSubsidyFundCost/edit", params).then(
                (res) => {
                  if (res.code == 200) {
                    this.visible = false;
                    this.$message.success("编辑成功");
                    this.$emit("foundPay");
                  } else {
                    this.$message.error(res.message);
                  }
                }
              );
            }
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    handleClearAcquireYear() {
      //  	console.log("111111");
      this.form.costYear = ""; // 或者适当的空值，根据你的业务需求
      this.$forceUpdate();
    },
    panelChangeOne(value) {
      //   	      console.log(value,"111111");
      // this.form.costYear = value;
      const year = moment(value).format("YYYY");
      this.form.costYear = year + "";
      this.yearShowOne = false;
      this.$refs.ruleForm.clearValidate("costYear");
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .ant-modal-title {
  text-align: center;
}

/deep/ .ant-input-number-handler-wrap {
  display: none;
}

.surplus-money {
  width: 200px;
  display: inline-block;
  margin-left: 12px;
}
</style>